// Standard breakpoints for responsive design
// Based on common device sizes and Ant Design conventions

export const breakpoints = {
  xs: 320,   // Small phones (iPhone SE)
  sm: 576,   // Phones
  md: 768,   // Tablets (iPad portrait)
  lg: 992,   // Small laptops / tablets landscape
  xl: 1200,  // Desktops
  xxl: 1600, // Large desktops
} as const;

// Media query helpers for styled-components
export const media = {
  xs: `@media (max-width: ${breakpoints.xs}px)`,
  sm: `@media (max-width: ${breakpoints.sm}px)`,
  md: `@media (max-width: ${breakpoints.md}px)`,
  lg: `@media (max-width: ${breakpoints.lg}px)`,
  xl: `@media (max-width: ${breakpoints.xl}px)`,
  xxl: `@media (max-width: ${breakpoints.xxl}px)`,

  // Min-width queries (mobile-first approach)
  minXs: `@media (min-width: ${breakpoints.xs + 1}px)`,
  minSm: `@media (min-width: ${breakpoints.sm + 1}px)`,
  minMd: `@media (min-width: ${breakpoints.md + 1}px)`,
  minLg: `@media (min-width: ${breakpoints.lg + 1}px)`,
  minXl: `@media (min-width: ${breakpoints.xl + 1}px)`,
} as const;

// Helper function for custom breakpoints
export const customMedia = (maxWidth: number) => `@media (max-width: ${maxWidth}px)`;
export const customMinMedia = (minWidth: number) => `@media (min-width: ${minWidth}px)`;
